<div class="modal-header">
    <h4 class="modal-title">{{ fileName }}</h4>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()" aria-label="Close"></button>
</div>

<div class="modal-body file-preview-body">
    <!-- Pour les images -->
    <div *ngIf="isImage" class="image-container">
        <img [src]="displayUrl" [alt]="fileName" class="img-fluid">
    </div>

    <!-- Pour les documents supportés par Google Viewer -->
   <!-- <ngx-doc-viewer *ngIf="useGoogleViewer" [url]="displayUrl" viewer="google" style="width:100%; height:80vh;">
    </ngx-doc-viewer>-->

    <iframe *ngIf="useGoogleViewer" [src]="sanitizedGoogleViewerUrl" style="width: 100%; height: 80vh"
        frameborder="0">
    </iframe>

    <!-- Pour les PDF (solution de repli) -->
    <embed *ngIf="useEmbed" [src]="safeUrl" type="application/pdf" width="100%" height="80vh">

    <!-- Pour les types non supportés -->
    <div *ngIf="isUnsupported" class="unsupported-file">
        <div class="alert alert-warning">
            <p>Le format de fichier n'est pas supporté pour la prévisualisation.</p>
            <a [href]="displayUrl" download="{{fileName}}" class="btn btn-primary">
                Télécharger le fichier
            </a>
        </div>
    </div>
</div>